import './Inicio.css';
import { useEffect, useState, useRef } from 'react';
import Header from './componentes/js/Header';
import Footer from './componentes/js/Footer';
import Galeria from './componentes/js/Galeria';
import GaleriaImagem from './componentes/js/GaleriaImagem';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Seções que vieram da antiga página "Matricule-se"
import './paginas/Landing/Matricula.css';
import DestaqueMatriculasSection from './paginas/Landing/secoes/DestaqueMatriculasSection';
import BeneficiosSection from './paginas/Landing/secoes/BeneficiosSection';
import DepoimentosSection from './paginas/Landing/secoes/DepoimentosSection';
import DiferenciaisSection from './paginas/Landing/secoes/DiferenciaisSection';

function Inicio() {
  const [isMobile, setIsMobile] = useState(false);
  const [expandido, setExpandido] = useState({});
  const instagramRef = useRef(null);

  // Vídeos do Instagram (depoimentos): o script do Instagram é pesado, então
  // só é carregado quando a seção chega perto da tela.
  useEffect(() => {
    const container = instagramRef.current;
    if (!container) return;
    let script;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.disconnect();
        script = document.createElement('script');
        script.src = 'https://www.instagram.com/embed.js';
        script.async = true;
        container.appendChild(script);
      }
    }, { rootMargin: '400px' });
    observer.observe(container);
    return () => {
      observer.disconnect();
      if (script && script.parentNode === container) container.removeChild(script);
    };
  }, []);

  // Links antigos para /matricule-se chegam aqui com #matricule-se:
  // rola até a faixa de matrículas depois que a página monta.
  useEffect(() => {
    if (window.location.hash === '#matricule-se') {
      const alvo = document.getElementById('matricule-se');
      if (alvo) setTimeout(() => alvo.scrollIntoView({ behavior: 'smooth', block: 'start' }), 300);
    }
  }, []);

  const numsAlunos = 
  [
    1800
  ]

  const Contador = ({ numero, duracao = 1000 }) => {
    const [valor, setValor] = useState(0);
    const [iniciou, setIniciou] = useState(false);
    const elementoRef = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIniciou(true);
            observer.disconnect();
          }
        },
        {
          threshold: 0.5
        }
      );

      if (elementoRef.current) {
        observer.observe(elementoRef.current);
      }

      return () => observer.disconnect();
    }, []);

    useEffect(() => {
      if (!iniciou) return;

      const inicio = performance.now();

      const atualizar = (agora) => {
        const progresso = Math.min((agora - inicio) / duracao, 1);

        const suavizado = 1 - Math.pow(1 - progresso, 3);

        setValor(Math.floor(numero * suavizado));

        if (progresso < 1) {
          requestAnimationFrame(atualizar);
        }
      };

      requestAnimationFrame(atualizar);
    }, [iniciou, numero, duracao]);

    return (
      <h3 ref={elementoRef}>
        {"+"+valor}
      </h3>
    );
  };

  const depos = [
    `No Colégio Líder, acreditamos que uma educação de qualidade começa com os melhores recursos.
    Por isso, adotamos o Sistema PH no Ensino Fundamental — um material didático de altíssima qualidade, reconhecido nacionalmente, 
    alinhado à Base Nacional Comum Curricular (BNCC) e pensado para estimular o desenvolvimento integral dos alunos.
    Com conteúdos completos, linguagem acessível e ferramentas digitais integradas, o material promove uma aprendizagem dinâmica, que 
    desperta a curiosidade, incentiva a autonomia e fortalece o pensamento crítico.
    Mais do que preparar para os desafios acadêmicos, nosso objetivo é formar jovens confiantes, capazes de enfrentar o mundo com 
    responsabilidade e conhecimento.`,
    `No Colégio Líder, o Ensino Médio conta com um parceiro de peso na jornada acadêmica, o Sistema de Ensino Poliedro.
    Reconhecido nacionalmente pelos excelentes resultados nos vestibulares mais concorridos, o Poliedro oferece conteúdos completos, atualizados e aprofundados, pensados para preparar os alunos com eficiência e confiança.
    Além dos livros didáticos de alta qualidade, os estudantes têm acesso a uma plataforma digital interativa, simulados, banco de questões e diversos recursos complementares que tornam o estudo mais dinâmico e direcionado.
    Com o Poliedro, nossos alunos vivem uma experiência de ensino de alto desempenho, que amplia suas oportunidades e os aproxima da realização dos seus sonhos e projetos de vida.
    `,
    `No Colégio Líder, acreditamos que educar vai além dos conteúdos acadêmicos. Por isso, adotamos o Programa SEE – Socioemocional e Ética, 
    que trabalha de forma estruturada o desenvolvimento das habilidades socioemocionais dos alunos.

    Com atividades práticas, reflexões e dinâmicas, o SEE estimula competências como empatia, autoconhecimento, resiliência, colaboração e 
    responsabilidade ética. O programa contribui para a formação integral dos estudantes, preparando-os para lidar com desafios pessoais, 
    acadêmicos e sociais.

    Assim, nossos alunos aprendem não apenas a alcançar excelentes resultados escolares, mas também a se tornarem cidadãos conscientes e 
    preparados para o futuro.`,
    `No Colégio Líder, oferecemos aos nossos alunos a oportunidade de aprender inglês com a qualidade de uma das maiores redes de ensino de 
    idiomas do país: o CNA.

    As aulas são ministradas dentro do colégio, garantindo praticidade, conforto e integração com a rotina escolar. Com metodologia moderna, 
    dinâmica e comunicativa, o CNA desenvolve as quatro habilidades da língua (ouvir, falar, ler e escrever), preparando os estudantes para 
    se comunicarem de forma eficaz no mundo globalizado.

    Essa parceria amplia as oportunidades de aprendizado e proporciona aos nossos alunos uma formação completa, unindo excelência acadêmica 
    e proficiência em inglês.`,
    `No Colégio Líder, ampliamos a formação em inglês dos nossos alunos por meio do English Stars, um programa de ensino bilíngue 
    reconhecido por sua metodologia consistente e alinhada às exigências do mundo contemporâneo.
    Com atuação da Educação Infantil aos Anos Finais do Ensino Fundamental, o English Stars adota a abordagem CLIL (Content and 
    Language Integrated Learning), integrando o aprendizado do inglês aos conteúdos curriculares e tornando a imersão no idioma 
    parte natural da rotina escolar. Todas as aulas são ministradas totalmente em inglês, o que potencializa o desenvolvimento 
    das quatro habilidades da língua — ouvir, falar, ler e escrever — de forma integral.
    Alinhada às competências do século 21 previstas na Base Nacional Comum Curricular (BNCC), a metodologia Stars vai além do 
    ensino tradicional de idiomas: forma alunos mais autônomos, comunicativos e preparados para os desafios de um mundo cada vez 
    mais globalizado.
    Essa parceria reforça o compromisso do Colégio Líder com uma educação completa, que une excelência acadêmica, formação 
    bilíngue de qualidade e preparo real para o futuro dos nossos alunos.`,
    `No Colégio Líder, incentivamos o hábito da leitura e o desenvolvimento das habilidades de escrita dos nossos alunos por meio da 
    Árvore, uma plataforma educacional completa que une tecnologia, literatura e pedagogia.
    Com um acervo digital de mais de 120 mil títulos entre livros, audiolivros, jornais e revistas, além de livros físicos 
    entregues ao longo do ano letivo, a Árvore oferece aos estudantes, da Educação Infantil ao Ensino Médio, recomendações de 
    leitura personalizadas por inteligência artificial e recursos de gamificação que tornam a experiência leitora mais engajadora.
    A plataforma também conta com ferramentas de avaliação — como a Avaliação de Fluência Leitora, baseada em neurociência, e o 
    nivelamento por proficiência — que permitem acompanhar de perto a evolução de cada aluno e personalizar o ensino de acordo 
    com suas necessidades. O programa SuperAutores complementa essa jornada, estimulando também a produção escrita dos estudantes.
    Alinhada à Base Nacional Comum Curricular (BNCC), a Árvore contribui para formar leitores mais críticos, autônomos e 
    preparados para os desafios do século 21 — reforçando o compromisso do Colégio Líder com uma educação completa, que valoriza 
    a leitura como ferramenta essencial de aprendizagem e desenvolvimento.`,
  ]


  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) || /iPhone|iPad|iPod/i.test(userAgent)) {
      setIsMobile(true);
    }

    const elementosAnimados = document.querySelectorAll('.elemento-animado, .elemento-animado-esquerda, .elemento-animado-direita, .elemento-animado-down');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('entrou-na-tela');
        }
      });
    }, { threshold: 0.4 });

    elementosAnimados.forEach(elemento => {
      observer.observe(elemento);
    });

    return () => {
      elementosAnimados.forEach(elemento => {
        observer.unobserve(elemento);
      });
    };
  }, []);

  const renderTexto = (id, texto, limite) => {
    const textoCortado = texto.substring(0, limite) + "...";
    const isExpandido = expandido[id];

    return (
      <>
        {isExpandido ? texto : textoCortado}
        <button 
          className="verMais"
          onClick={() => toggleExpand(id)}
          style={{ marginBottom: 10 }}
        >
          {isExpandido ? "Ver Menos" : "Ver Mais"}
        </button>
      </>
    );
  };

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
    if ('caches' in window) {
      caches.keys().then((names) => {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }
  }

  const toggleExpand = (id) => {
    setExpandido(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const importAllImages = (requireContext) => {
    return requireContext.keys().map(requireContext);
  };

  return (
    <div style={{backgroundImage: 'url(assets/images/fundo/fundo2.png)', backgroundSize: isMobile ? '60%' : '25%', backgroundPosition: 'center', backgroundRepeat: 'repeat', marginBottom: '-16vh'}}>
      <main>
        <Header />
      <div className='fundoInicio'>
        <img src='assets/images/inicio.png' alt="Banner" className='bannerInicio' />
        <div style={{width: '100%', textAlign: 'center', position: 'absolute', bottom: '6%', left: 0, zIndex: 100}}>
          <a
            href='https://api.whatsapp.com/send?phone=5562998271550&text=Bom%20dia!'
            target='_blank'
            rel='noopener noreferrer'
            className='actionButton'
            style={{display: 'inline-flex', textAlign: 'center', justifyContent: 'center', alignItems: 'center', margin: 'auto', padding: '14px 28px', fontSize: 35 + 'px', backgroundColor: '#ffffff', borderWidth: 2 + 'px', borderStyle: 'solid', borderColor: 'rgba(63, 63, 63, 0.2)'}}
          >
            <h3 style={{textDecoration: 'underline', color: '#121e62', margin: 0, fontWeight: 1000}}>MATRICULE-SE JÁ!</h3>
          </a>
        </div>
      </div>

      <DestaqueMatriculasSection />

      <div className="card-container elemento-animado-down">
        <a href='ensino-fundamental-1' className="carta-inicio">
            <h3>FUNDAMENTAL I</h3>
            <div className="card-inner">
                <div className="card-front">
                    <div className="card-content">
                        <img src="assets/images/banners/fundamental.png" alt="Imagem 1" />
                    </div>
                </div>
                <div className="card-back">
                  <img src="assets/images/banners/fundamentalB.png" alt="Imagem 2" />
                </div>
            </div>
        </a>

        <a href='ensino-fundamental-2' className="carta-inicio">
          <h3>FUNDAMENTAL II</h3>
            <div className="card-inner">
                <div className="card-front">
                    <div className="card-content">
                        <img src="assets/images/banners/fundamental2.png" alt="Imagem 2" />
                    </div>
                </div>
                <div className="card-back">
                      <img src="assets/images/banners/fundamental2B.png" alt="Imagem 2" />
                </div>
            </div>
        </a>

        <a href='ensino-medio' className="carta-inicio">
            <h3>ENSINO MÉDIO</h3>
            <div className="card-inner">
                <div className="card-front">
                    <div className="card-content">
                        <img src="assets/images/banners/medio.png" alt="Imagem 3" />
                    </div>
                </div>
                <div className="card-back">
                  <img src="assets/images/banners/medioB.png" alt="Imagem 2" />
                </div>
            </div>
        </a>
      </div>

      <div className="grid-container elemento-animado-direita">
        <div className="grid-item elemento-animado-direita">
          <div className="imagem img-selo">
            <img src="assets/images/selo.png" alt="Selo Colégio Líder"/>
          </div>
          <div className="texto">
            <h1 style={{fontFamily: 'Vend Sans', fontWeight: '700', color: '#121e62'}}>COLÉGIO LÍDER</h1>
            <h2 style={{fontFamily: 'Vend Sans', fontWeight: '700', color: '#e9dd00', border: '0'}}>VOCÊ SEMPRE À FRENTE!</h2>
            <hr className="amarelo"/>
            <p>
              Na hora de escolher uma escola, cada detalhe importa. No Colégio Líder, acreditamos que educar vai muito 
              além da sala de aula: é preparar nossos alunos para conquistar seus objetivos, desenvolver seu potencial e 
              construir um futuro de possibilidades.
            </p>
            <div className="numeros-selo">
              <div className="numero-item">
                {/* O Contador já renderiza o próprio <h3> */}
                <Contador numero={numsAlunos[0]} duracao={2000} />
                <p>ALUNOS QUE FAZEM PARTE DA NOSSA HISTÓRIA</p>
              </div>
            </div>
          </div>  
        </div>
      </div>

      {/* "Por que escolher nosso colégio?" + diferenciais, num bloco só */}
      <div className="inicio-secao">
        <BeneficiosSection />
        <DiferenciaisSection semTitulo />
      </div>

      <div className="aprovados-container">
        <div className="fundo">
          <h1 style={{color: '#121e62'}}>Aprovados</h1>
        </div>
        <div className='conteudo-aprovados'>
          <GaleriaImagem />
        </div>
      </div>

      <div className="inicio-secao">
        <DepoimentosSection embedRef={instagramRef} />
      </div>

      <div className='parceiros-container'>
        <h2 style={{"fontSize": 38 + "px"}}>Nossos parceiros</h2>
        <div className='parceiros-container-inner'>
        <div className='parceiros-caixa'>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img src='assets/images/sistemas/sistema-de-ensino-ph.png' alt="Material Didático PH SOMOS"></img>
          </div>

          <h3 style={{textAlign: 'center'}}>Material Didático PH SOMOS</h3>

          {renderTexto("ph", depos[0], 180)}
        </div>
        <div className='parceiros-caixa'>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img src='assets/images/sistemas/poliedro.png' alt="Sistema Poliedro – Ensino Médio"></img>
          </div>

          <h3 style={{textAlign: 'center'}}>Sistema Poliedro – Ensino Médio</h3>

          {renderTexto("poliedro", depos[1], 180)}
          </div>
        <div className='parceiros-caixa'>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img src='assets/images/sistemas/see.png' alt="Programa SEE – Socioemocional e Ética"></img>
          </div>

          <h3 style={{textAlign: 'center'}}>Programa SEE – Socioemocional e Ética</h3>

          {renderTexto("see", depos[2], 180)}
        </div>
        <div className='parceiros-caixa'>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img src='assets/images/sistemas/cna.png' alt="Parceria com o CNA"></img>
          </div>

          <h3 style={{textAlign: 'center'}}>Parceria com o CNA</h3>

          {renderTexto("cna", depos[3], 220)}
        </div>
        <div className='parceiros-caixa'>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img style={{width: '100%', height: '100%'}}  src='assets/images/sistemas/english-stars.png' alt="English Stars"></img>
          </div>

          <h3 style={{textAlign: 'center'}}>English Stars</h3>

          {renderTexto("english-stars", depos[4], 220)}
        </div>
        <div className='parceiros-caixa'>
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img style={{width: '100%', height: '100%'}} src='assets/images/sistemas/arvore.png' alt="Plataforma Árvore"></img>
          </div>

          <h3 style={{textAlign: 'center'}}>Plataforma Árvore</h3>

          {renderTexto("arvore", depos[5], 220)}
        </div>
      </div>
      </div>
    
      <div className="alunoOnline elemento-animado-esquerda">
          <div className="centralAlunoContainer">
              <div className="botaoContainer">
                  <a href="https://cpa.escolarmanageronline.com.br/colegiolider" rel='noreferrer' target='_blank'><button className="centralAluno">ACESSAR CENTRAL DO ALUNO</button></a>
                  <a href="https://professor.escolarmanageronline.com.br/colegiolider/Login" rel='noreferrer' target='_blank'><button className="centralAluno">ACESSAR PORTAL DO PROFESSOR</button></a>
              </div>
          </div>
      </div>

      </main>
      <Footer />
    </div>
  );
}

export default Inicio;
